import { StickerFrame, type StickerArtProps } from './StickerFrame';

export function Nature(props: StickerArtProps) {
  return (
    <StickerFrame background="#65a30d" {...props}>
      <rect x="30.5" y="34" width="3" height="18" fill="#ffffff" />
      <ellipse cx="39" cy="45" rx="6" ry="3" fill="#ffffff" transform="rotate(-30 39 45)" />
      <circle cx="32" cy="18.5" r="6.5" fill="#ffffff" />
      <circle cx="41" cy="25" r="6.5" fill="#ffffff" />
      <circle cx="37.5" cy="35" r="6.5" fill="#ffffff" />
      <circle cx="26.5" cy="35" r="6.5" fill="#ffffff" />
      <circle cx="23" cy="25" r="6.5" fill="#ffffff" />
      <circle cx="32" cy="28" r="5.5" fill="#facc15" stroke="#1f2937" strokeWidth="1.5" />
    </StickerFrame>
  );
}
